@if (maintenance$ | async; as maintenance) {
@if (maintenance.activated) {
<app-maintenance [maintenance]="maintenance"></app-maintenance>
}@else {
<div class="page">
  @if (!isHomePage && !isCGGCPage) {
  <div id="page-header" class="page-header">
    <app-header [(menuDisplay)]="menuDisplay" [isLoggedIn]="isLoggedIn()"></app-header>
  </div>
  }
  <div class="page-main" [ngClass]="(!isHomePage && isLoggedIn() && !isCGGCPage) || canAccessWithoutLogged ? 'pt-3':''">
    @if (!isHomePage && !canAccessWithoutLogged && !isCGGCPage) {
    <div class="page-main-menu z-2">
      <app-menu [(menuDisplay)]="menuDisplay" [isLoggedIn]="isLoggedIn()"
        (createDispositif)="createDispositif($event)"></app-menu>
    </div>
    }
    <div [ngClass]="{
          'page-main-outlet-home': isHomePage && isLoggedIn(),
          'page-main-outlet': (!isHomePage && isLoggedIn() && !isCGGCPage) || canAccessWithoutLogged,
          'page-main-accueil': !isLoggedIn() && !canAccessWithoutLogged,
          'page-main-full': isCGGCPage
        }">
      <router-outlet></router-outlet>
    </div>
  </div>
  @if (!isCGGCPage){
  <div class="page-footer z-3">
    <app-footer [isLoggedIn]="isLoggedIn()"></app-footer>
  </div>
  }
</div>
<p-toast position="top-center">
  <ng-template let-message pTemplate="message">
    <div class="row">
      <div class="toast-message">
        <div class="material-icons-outlined" [textContent]="
                message.severity === 'warn'
                  ? 'warning'
                  : message.severity === 'error'
                  ? 'error_outline'
                  : 'check_circle'
              "></div>
        <div class="toast-message-text">
          <div class="toast-message-title" [textContent]="message.summary"></div>
          <div class="toast-message-content" [innerHtml]="message.detail"></div>
        </div>
      </div>
      @if(message.data?.redirectUrl){
      <div class="toast-button">
        <lib-button class="toast-button-success" text="OK" backgroundColor="none"
          (onClick)="redirect(message.data?.redirectUrl)"></lib-button>
      </div>
      }
    </div>
  </ng-template>
</p-toast>

<p-toast key="error-toast" position="center">
  <ng-template let-message pTemplate="message">
    <div class="row">
      <div class="toast-message">
        <div class="material-icons-outlined" [textContent]="
                message.severity === 'warn'
                  ? 'warning'
                  : message.severity === 'error'
                  ? 'highlight_off'
                  : 'check_circle'
              "></div>
        <div class="toast-message-text">
          <div class="toast-message-title" [textContent]="message.summary"></div>
          <div class="toast-message-content" [innerHtml]="message.detail"></div>
        </div>
      </div>

      <div class="toast-button">
        <lib-button class="toast-button-error" text="OK" backgroundColor="none" (onClick)="onClickOk('error-toast', $event)"></lib-button>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-toast key="success-toast" position="top-center">
  <ng-template let-message pTemplate="message">
    <div class="row">
      <div class="toast-message">
        <div class="material-icons-outlined" [textContent]="
                message.severity === 'warn'
                  ? 'warning'
                  : message.severity === 'error'
                  ? 'highlight_off'
                  : 'check_circle'
              "></div>
        <div class="toast-message-text">
          <div class="toast-message-title" [textContent]="message.summary"></div>
          <div class="toast-message-content" [innerHtml]="message.detail"></div>
        </div>
      </div>

      <div class="toast-button">
        <lib-button class="toast-button-success" text="OK" backgroundColor="none" (onClick)="onClickOk('success-toast', $event)"></lib-button>
      </div>
    </div>
  </ng-template>
</p-toast>
}
}
